import { render, staticRenderFns } from "./ActBaseCouponList.vue?vue&type=template&id=6c131d3e&scoped=true&"
import script from "./ActBaseCouponList.vue?vue&type=script&lang=js&"
export * from "./ActBaseCouponList.vue?vue&type=script&lang=js&"
import style0 from "./ActBaseCouponList.vue?vue&type=style&index=0&id=6c131d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c131d3e",
  null
  
)

export default component.exports